import React from 'react';
import { StyledBox, StyledFlexContainer } from './Home.styled';
import AttractionSection from './sections/AttractionSection';
import FavouriteSection from './sections/FavouriteSection';
import BCSection from './sections/BCSection';
import GameFinderSection from './sections/GamefinderSection';
import ProviderPricesSection from './sections/ProviderPricesSection';
import Footer from '../footer/Footer';
const Home: React.FC = () => {
  return (
    <>
      <StyledBox>
        <AttractionSection />
        <StyledFlexContainer>
          <FavouriteSection />
          <BCSection />
          <GameFinderSection callType="home" />
          <ProviderPricesSection />
        </StyledFlexContainer>
      </StyledBox>
      <Footer />
    </>
  );
};

export default Home;
